var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDirections = function SvgDirections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.435,
    height: 13.435,
    x: 12.5,
    y: 3,
    stroke: "currentColor",
    strokeLinejoin: "round",
    rx: 2,
    transform: "rotate(45 12.5 3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M16.53 11.829h-6.485c-.877 0-1.595.699-1.617 1.576l.04 1.782m8.061-3.358-3.297 3.358m3.297-3.358-3.297-3.36"
  })));
};
export { SvgDirections as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTIuNSIgeT0iMyIgd2lkdGg9IjEzLjQzNSIgaGVpZ2h0PSIxMy40MzUiIHJ4PSIyIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxMi41IDMpIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTYuNTI5MyAxMS44Mjg1TDEwLjA0NTEgMTEuODI4NUM5LjE2NzgyIDExLjgyODUgOC40NTA0IDEyLjUyNzggOC40Mjc5NyAxMy40MDQ4VjEzLjQwNDhMOC40NjgyOCAxNS4xODcyTTE2LjUyOTMgMTEuODI4NUwxMy4yMzE2IDE1LjE4NzJNMTYuNTI5MyAxMS44Mjg1TDEzLjIzMTYgOC40Njk3MyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";